var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-button button-personal",on:{"click":function($event){return _vm.openCabinet()}}},[(_vm.isAuthorize)?_c('span',{staticClass:"balloon bonus-balance"},[_vm._v(_vm._s(_vm.bonuses))]):_vm._e(),_c('span',{staticClass:"pp-icon pp-icon-personal"})])
}
var staticRenderFns = []

export { render, staticRenderFns }